import { render, staticRenderFns } from "./UiBlockDocUpload.vue?vue&type=template&id=402e5be9&scoped=true"
import script from "./UiBlockDocUpload.vue?vue&type=script&lang=js"
export * from "./UiBlockDocUpload.vue?vue&type=script&lang=js"
import style0 from "./UiBlockDocUpload.vue?vue&type=style&index=0&id=402e5be9&prod&scoped=true&lang=css"
import style1 from "./uiBlockShared.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402e5be9",
  null
  
)

export default component.exports